"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * {@docCategory ResizeGroup}
 */
var ResizeGroupDirection;
(function (ResizeGroupDirection) {
    ResizeGroupDirection[ResizeGroupDirection["horizontal"] = 0] = "horizontal";
    ResizeGroupDirection[ResizeGroupDirection["vertical"] = 1] = "vertical";
})(ResizeGroupDirection = exports.ResizeGroupDirection || (exports.ResizeGroupDirection = {}));
//# sourceMappingURL=ResizeGroup.types.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/ResizeGroup/ResizeGroup.types.js
// module id = 744
// module chunks = 0